var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('BCarousel',{attrs:{"id":"carousel-1","interval":0,"controls":"","background":"transparent"}},_vm._l((_vm.projects),function(slide,index){return _c('CarouselSlide',{key:index,attrs:{"slide-content":slide}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }